// npm
import React from 'react'

export default function Text() {
  return <p>Text Page</p>
}
